import { render, staticRenderFns } from "./IdeaVisualDetailed.vue?vue&type=template&id=417f49bf&"
import script from "./IdeaVisualDetailed.vue?vue&type=script&lang=js&"
export * from "./IdeaVisualDetailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports